export class BetaFeature {
    public BetaFeatureList: Array<string> = [
        BetaFeature.TestGpsOff,
        BetaFeature.PRIORITY_ORDER,
        BetaFeature.Feature,
        BetaFeature.Disable2FA,
        BetaFeature.HeatmapRandomPoly,
        BetaFeature.NewBookingsReports,
        BetaFeature.ShowCustomerPhone,
        BetaFeature.PAUSE_COMMERCE,
        BetaFeature.RESUME_COMMERCE,
        BetaFeature.ANTI_FRAUD_TRANSACTIONS,
        BetaFeature.PAYMENT_GATEWAY_MAYA,
        BetaFeature.PAYMENT_GATEWAY_XENDIT
    ];

    public static TestGpsOff: string = 'TestGpsOff';

    public static PRIORITY_ORDER: string = 'PriorityOrder';

    public static Disable2FA: string = 'Disable2FA';

    public static Feature: string = 'Feature';

    public static ADJUST_WALLET: string = 'AdjustWallet';

    public static ShowZonesmap: string = 'ShowZonesmap';

    public static HeatmapRandomPoly: string = 'HeatmapRandomPoly';

    public static EditGeoZones: string = 'EditGeoZones';

    public static ExportAvgReport: string = 'ExportAvgReport';

    public static NewBookingsReports: string = 'NewBookingsReports';

    public static ShowCustomerPhone: string = 'ShowCustomerPhone';

    public static Reward4wRxpRider: string = 'Reward4wRxpRider';

    public static ImageManagement: string = 'ImageManagement';

    public static WEEKLY_USER_WALLET_TOP_UP: string = 'WeeklyUserWalletTopUp ';

    public static HIGHER_LIMIT_PLACE_ORDER: string = 'HigherLimitPlaceOrder';

    public static PAUSE_COMMERCE: string = 'PauseCommerce';

    public static RESUME_COMMERCE: string = 'ResumeCommerce';

    public static ANTI_FRAUD_TRANSACTIONS: string = 'AntiFraudTransactions';

    /** Routes this user's new card and Maya-wallet bindings to the Maya gateway. Existing bindings keep their own gateway. */
    public static PAYMENT_GATEWAY_MAYA: string = 'PaymentGatewayMaya';

    /** Pins this user's new bindings to Xendit, overriding a global switch to Maya. */
    public static PAYMENT_GATEWAY_XENDIT: string = 'PaymentGatewayXendit';
}
